// @ts-ignore
import { run_app } from "../Cargo.toml"

run_app()